import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useParams, useHistory, useLocation } from 'react-router';
import queryString from 'query-string';
import isObject from 'lodash/isObject';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';

// Types
import { FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';
import { ReviewTemplateType } from 'Shared/types/ReviewTemplates.type';

//Components
import GiveFeedbackModal from 'Dashboard/components/GiveFeedbackPage/GiveFeedbackModal';
import FeedbackForm from './FeedbackForm/FeedbackForm';

//Constants
import { choseFeedbackTemplateEvent } from 'Shared/constants/constants';

function FeedbackCreationPage() {
  const history = useHistory();
  const [choosenTemplate, setChoosenTemplate] = useState(null);

  const { workspaceId, feedbackRecognitionRequestId } = useParams();

  const { pathname, search, state = {} } = useLocation();

  const isEditFeedbackPage = pathname.includes('edit');
  const isCreateFeedbackPage = !isEditFeedbackPage;

  const { template } = queryString.parse(search);

  useEffect(() => {
    if (isCreateFeedbackPage && !choosenTemplate && template) {
      setChoosenTemplate(template);
    } else if (isCreateFeedbackPage && !choosenTemplate && !template) {
      setChoosenTemplate(FeedbackRecognitionTemplateTypes.feedbackStrengthsOpportunitiesTemplate);
    }
  }, []);

  const handleChooseTemplate = (selectedTemplate: String | ReviewTemplateType) => {
    const handleSetTemplateSelection = (template: string, slug?: string) => {
      setChoosenTemplate(template);
      (window as any).analytics.track(choseFeedbackTemplateEvent, { selectedTemplate: template });
      history.push({
        pathname: `${PageUrlsUtil.makeFeedbackFormUrl(workspaceId, feedbackRecognitionRequestId)}`,
        search: `template=${template}${slug ? `&review_template_slug=${slug}` : ''}`,
        state,
      });
    };

    if (isObject(selectedTemplate)) {
      // @ts-ignore
      const template = selectedTemplate.template as ReviewTemplateType;

      if (!template.isCustom) {
        handleSetTemplateSelection(template.slug);
      } else {
        handleSetTemplateSelection(FeedbackRecognitionTemplateTypes.feedbackfromReviewTemplateTemplate, template.slug);
      }
    } else {
      handleSetTemplateSelection(selectedTemplate as string);
    }
  };

  const handleCloseModal = () => {
    history.push(PageUrlsUtil.makeWorkspaceFeedbackUrl(workspaceId));
  };

  return (
    <>
      <div className="FeedbackCreation">
        <Switch>
          <Route
            path={['/workspaces/:workspaceId/feedback_request/:feedbackRecognitionRequestId?']}
            render={() => (
              <GiveFeedbackModal isOpen toggleOpen={handleCloseModal} handleChooseTemplate={handleChooseTemplate} />
            )}
          />
          <Route
            path={[
              '/workspaces/:workspaceId/feedback_form/:feedbackUuid/edit',
              '/workspaces/:workspaceId/feedback_form/:feedbackRecognitionRequestId?',
            ]}
            render={() => <FeedbackForm choosenTemplate={choosenTemplate} />}
          />
        </Switch>
      </div>
    </>
  );
}

export default FeedbackCreationPage;
